import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/full-service-medical-device-cro")({
  head: () => buildRouteHead("/es/servicios/full-service-medical-device-cro", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/clinical-solutions/ensayos-clinicos-de-dispositivos-medicos", replace: true });
  },
});
